import cx from 'classnames';

import { Flex } from '@common/components/Flex';
import { Ellipsis } from '@common/components/Ellipsis';
import { MODULE_NAME } from '../../../../../../audit-report';

import './user.styles.scss';

export const User =  React.memo((props) =>{
  const { selected, onClick, username, style } = props;

  const handleClick = React.useCallback(() => {
    onClick(username);
  }, [onClick, username]);

  return (
    <Flex  
      style={style}
      id={`${MODULE_NAME}-filter-user`} 
      alignItems="center" 
      className={cx('FieldAuditReportUser', { 'FieldAuditReportUser--selected': selected })} 
      onClick={handleClick}
    >
      <input readOnly type="checkbox" className="FieldAuditReportUser__checkbox" checked={selected} />
      <Ellipsis text={username} />
    </Flex>
  );
});